import { type MutationHookOptions, useMutation } from "@apollo/client";
import { SetContractPaymentStatusMutation } from "../graphql/mutations";
import type {
  SetContractPaymentStatusMutationType,
  SetContractPaymentStatusMutationVariablesType,
} from "@/types/graphql/admin.generated";

export const useSetContractPaymentStatusMutation = (
  options?: MutationHookOptions<
    SetContractPaymentStatusMutationType,
    SetContractPaymentStatusMutationVariablesType
  >
) => {
  return useMutation<
    SetContractPaymentStatusMutationType,
    SetContractPaymentStatusMutationVariablesType
  >(SetContractPaymentStatusMutation, options);
};
